import { render, staticRenderFns } from "./LayoutHeader.vue?vue&type=template&id=aa07fbdc&scoped=true"
import script from "./LayoutHeader.vue?vue&type=script&lang=js"
export * from "./LayoutHeader.vue?vue&type=script&lang=js"
import style0 from "./LayoutHeader.vue?vue&type=style&index=0&id=aa07fbdc&prod&lang=less"
import style1 from "./LayoutHeader.vue?vue&type=style&index=1&id=aa07fbdc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa07fbdc",
  null
  
)

export default component.exports